import React from 'react';
import PropTypes from 'prop-types';
import {Outlet} from 'react-router-dom';

import GlobalContext from './helpers/context';
import AppHeader from './appHeader';


class AppLayout extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <AppHeader logoutCallBack={this.props.logoutCallBack} user={this.props.user} pathName={this.props.pathName} params={this.props.params}/>
                <Outlet />
            </div>
        );
    }

}

AppHeader.contextType = GlobalContext;

AppLayout.propTypes = {
    logoutCallBack: PropTypes.func,
    user: PropTypes.object,
    pathName: PropTypes.string,
    params: PropTypes.object
};


export default AppLayout;
